module.exports = "<mat-card class=\"container\">\n  <mat-card-title>\n    <img src=\"/assets/logo.png\" class=\"logo\" alt=\"Overhand Logo\">\n  </mat-card-title>\n  <mat-card-content>\n    <mat-list>\n      <mat-list-item *ngFor=\"let option of menuOptions | keys\">\n        <a [ngClass]=\"{'activeButton': isCurrentPage(option.key) }\" (click)=\"goTo(option.key)\">{{option.value}}</a>\n      </mat-list-item>\n    </mat-list>\n  </mat-card-content>\n</mat-card>"


//////////////////
// WEBPACK FOOTER
// /usr/src/app/src/app/components/menu/menu.component.html
// module id = ../../../../../src/app/components/menu/menu.component.html
// module chunks = main